import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import Header from './Header';
import Footer from './Footer';
import TableOfContents, { ContentsItem } from './TableOfContents';

interface BlogPostLayoutProps {
  title: string;
  children: React.ReactNode;
  contents?: ContentsItem[];
}

function BlogPostLayout({ title, children, contents }: BlogPostLayoutProps) {
  return (
    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <article className={`content-section blog-post-page ${contents ? 'blog-post-page--with-contents' : ''}`}>
          <div className="blog-post-container">
            <p className="blog-post-back">
              <Link to="/help-and-advice">← Back to Help and Advice</Link>
            </p>
            <h1 className="blog-post-title">{title}</h1>
            {contents ? (
              <div className="blog-post-body">
                <TableOfContents items={contents} />
                <div className="blog-post-content">
                  {children}
                </div>
              </div>
            ) : (
              <div className="blog-post-content">
                {children}
              </div>
            )}
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}

export default BlogPostLayout;
